import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { CacheService } from './core/services/cache.service';
import { ScriptService } from './core/services/script.service';
import { EntryPageComponent } from './pages/entry-page/entry-page.component';
import { SharedModule } from './shared/shared.module';




@NgModule({
    declarations: [
        AppComponent,
        EntryPageComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
        CoreModule,
        NgbModule,
    ],
    providers: [ScriptService,CacheService],
    bootstrap: [AppComponent],
})
export class AppModule {

}
